import { Reveal } from './Reveal';
import { SerapeUnderline } from './Serape';

export const PageHero = ({ overline, title, subtitle, image, testid }) => (
  <section data-testid={testid} className="relative pt-36 pb-16 md:pt-48 md:pb-24 overflow-hidden bg-brand-night">
    {image ? (
      <>
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-night/75 via-brand-night/60 to-brand-night" />
      </>
    ) : (
      <div className="pattern-dots-warm absolute inset-0 opacity-60" aria-hidden="true" />
    )}
    <div className="relative mx-auto max-w-7xl px-6 md:px-12 text-brand-cream">
      <Reveal>
        {overline && (
          <p className="uppercase text-sm tracking-[0.3em] font-semibold mb-4 text-brand-gold">
            {overline}
          </p>
        )}
        <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-none max-w-4xl text-balance">
          {title}
        </h1>
        <SerapeUnderline className="mt-6" />
        {subtitle && (
          <p className="mt-6 text-lg max-w-2xl text-brand-cream/75">
            {subtitle}
          </p>
        )}
      </Reveal>
    </div>
  </section>
);
